import { render, staticRenderFns } from "./NewChatDialogHeaderToolbar.vue?vue&type=template&id=2660f053&scoped=true&"
import script from "./NewChatDialogHeaderToolbar.vue?vue&type=script&lang=js&"
export * from "./NewChatDialogHeaderToolbar.vue?vue&type=script&lang=js&"
import style0 from "./NewChatDialogHeaderToolbar.vue?vue&type=style&index=0&id=2660f053&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2660f053",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VIcon,VSpacer,VToolbar,VToolbarTitle})
